<script>
import { Bar } from "vue-chartjs";

export default {
  props: {
    labelsChart: Array,
    data: Array,
    datasetsLabel: String,
    color: String,
    colorHover: String
  },


  extends: Bar,
  mounted() {
    this.renderChart(
      {
        labels: this.labelsChart,
        datasets: this.data,
        
          // {
          //   label: 'NDC',
          //   data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          //   backgroundColor: '#d81b60',
          //   stack: 'Stack 0',
          // },
          // {
          //   label: 'RDV',
          //   data: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
          //   backgroundColor: '#1e88e5',
          //   stack: 'Stack 0',
          // },
          // {
          //   label: 'RDV 4.0',
          //   data: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
          //   backgroundColor: "#4caf50",
          //   stack: 'Stack 0',
          // },
        
      },
      
      {
        tooltips: {
          enabled: true,
          callbacks: {
              label: function(context) {
                  return context.yLabel.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
              }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: {
            stacked: true,
          },
          yAxes: {
            stacked: true
          }
        }
      }
    );
  }
};
</script>